import styled from '@emotion/styled'

const StyledContent = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
`

export default StyledContent
